import React, { useEffect, useState } from 'react';
import {
    Alert, Box, Card, CardActionArea, CardContent, CircularProgress, Stack, Typography
} from '@mui/material';
import { listLibraryItems } from './apiLibrary';
import { formatDate } from './libraryConstants';
import StatusChip from './StatusChip';

// The caller's own items that aren't published yet. Opening one shows the
// detail drawer, which has the reviewer's note and the Edit / Submit buttons.
const MyDrafts = ({ groupId, refreshKey, onOpenItem }) => {
    const [items, setItems] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        listLibraryItems(groupId, { mine: 'true', status: 'draft,in_review', limit: 200, sort: 'code' }).then(res => {
            if (cancelled) return;
            if (res.error) setError(res.error);
            else { setError(''); setItems(res.items); }
        });
        return () => { cancelled = true; };
    }, [groupId, refreshKey]);

    if (error) return <Alert severity="error">{error}</Alert>;
    if (!items) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress /></Box>;
    if (!items.length) {
        return <Typography color="text.secondary" sx={{ py: 3 }}>You have no drafts or items waiting for review.</Typography>;
    }

    return (
        <Stack spacing={1}>
            {items.map(item => (
                <Card key={item._id} variant="outlined">
                    <CardActionArea onClick={() => onOpenItem(item._id)}>
                        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1.5, '&:last-child': { pb: 1.5 }, flexWrap: 'wrap' }}>
                            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                <Typography sx={{ fontWeight: 700, wordBreak: 'break-all' }}>{item.code} · r{item.revision}</Typography>
                                <Typography variant="body2" color="text.secondary" noWrap>{item.title || item.description || 'No title yet'}</Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Updated {formatDate(item.updatedAt)} · {item.files.length} file{item.files.length === 1 ? '' : 's'}
                                    {!item.files.some(f => f.kind === 'footprint_dwg') ? ' · footprint DWG still needed' : ''}
                                </Typography>
                            </Box>
                            <StatusChip status={item.status} />
                        </CardContent>
                    </CardActionArea>
                </Card>
            ))}
        </Stack>
    );
};

export default MyDrafts;
